export default __webpack_public_path__ + "static/media/annotation.57d1cf7d.png";